import { UserManager, WebStorageStateStore } from 'oidc-client-ts';
import { writable } from 'svelte/store';
import {getAppConfig} from "../helpers/app-config.helper";

let userManagerInstance: UserManager | undefined;

export function getUserManager(): UserManager {
    if (!userManagerInstance) {
        userManagerInstance = new UserManager(getConfig());

        userManagerInstance.events.addAccessTokenExpired(async () => {
            console.log('Token expired');
            try {
                await userManagerInstance!.signinSilent();
                console.log('Token refreshed');
            } catch {
                userManagerInstance!.signinRedirect();
            }
        });
    }

    return userManagerInstance;
}

export const authState = writable<'unknown' | 'checking' | 'ready' | 'redirecting'>('unknown');

function getConfig() {
    const appConfig = getAppConfig();
    const currentUrl = window.location.origin;

    return {
        authority: appConfig.keycloakAuthority,
        client_id: 'lisa-client',
        redirect_uri: `${currentUrl}/callback/`,
        response_type: 'code',
        post_logout_redirect_uri: currentUrl,
        userStore: new WebStorageStateStore({ store: window.localStorage }),
        accessTokenExpiringNotificationTime: 60,
    };
}